import React, { Component } from 'react';

export default class NotFound extends React.Component {

    render() {

        const pageStyle = {
            minHeight: '450px',
            textAlign: 'center'
        }

        return (
            <div id="content">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="w-90 mx-auto" style={pageStyle}>
                                <h2 className="error-code font-xs-x7 font-md-x10">
                                    404 <i className="fa fa-file-text text-primary font-xs-x6 font-md-x8"></i>
                                </h2>
                                <h2 className="error-message font-xs-x2 font-md-x2">Oops, This Page Could Not Be Found!</h2>
                            </div>
                        </div>
                        {/* <div className="col-md-4">
                            <h4>Maybe you were looking for:</h4>
                            <ul className="list-unstyled list-lg list-bordered">
                                <li><i className="fa fa-angle-right list-item-icon"></i> <a href="index.htm">Home</a></li>
                                <li><i className="fa fa-angle-right list-item-icon"></i> <a href="features.htm">Features</a></li>
                                <li><i className="fa fa-angle-right list-item-icon"></i> <a href="pricing.htm">Pricing</a></li>
                                <li><i className="fa fa-angle-right list-item-icon"></i> <a href="customers.htm">Customers</a></li>
                            </ul>
                            <form className="error-search mt-4">
                                <h4>Or Search for it:</h4>
                                <div className="input-group">
                                    <input type="text" className="form-control" placeholder="Search the site">
                                        <span className="input-group-btn">
                                            <button className="btn btn-secondary" type="button">Search</button>
                                        </span>
                                    </input>
                                </div>
                            </form>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/NotFound.js